import React, { useState } from "react";

import {
  RequestableSaasDestination,
  SaaSDestination,
  WarehouseDestination,
} from "../../../destinations/destinations";
import EditDestinationsModal from "./modals/EditDestinationsModal";
import BulkOperationConfirmationModal from "./modals/BulkOperationConfirmationModal";
import MenuButton from "../../../components/MenuButton";

export type BulkEditDestinationsMenuProps = {
  configurableDestinations: Record<
    string,
    | SaaSDestination
    | RequestableSaasDestination
    | WarehouseDestination
    | undefined
  >;
  selectedDestinations: string[];
  selectedEventIDs: string[];
  toggleEventForwarding: (destinationId: string, checked: boolean) => void;
};

function BulkEditDestinationsMenu({
  configurableDestinations,
  selectedDestinations,
  selectedEventIDs,
  toggleEventForwarding,
}: BulkEditDestinationsMenuProps) {
  const [editDestinationsModalOpen, setEditDestinationsModalOpen] = useState<
    boolean
  >(false);

  const [
    confirmEditDestinationsModalOpen,
    setConfirmEditDestinationsModalOpen,
  ] = useState<boolean>(false);

  const [destIDsToAdd, setDestIDsToAdd] = useState<Set<string>>(new Set());
  const [destIDsToRemove, setDestIDsToRemove] = useState<Set<string>>(
    new Set()
  );

  const saveDestinations = (
    destIDsToAdd: Set<string>,
    destIDsToRemove: Set<string>
  ) => {
    [...destIDsToAdd].forEach((destIDToAdd) => {
      toggleEventForwarding(destIDToAdd, true);
    });

    [...destIDsToRemove].forEach((destIDToRemove) => {
      toggleEventForwarding(destIDToRemove, false);
    });

    setDestIDsToAdd(new Set());
    setDestIDsToRemove(new Set());
    setConfirmEditDestinationsModalOpen(false);
    setEditDestinationsModalOpen(false);
  };

  return (
    <>
      {editDestinationsModalOpen && (
        <EditDestinationsModal
          configurableDestinations={configurableDestinations}
          onClose={() => setEditDestinationsModalOpen(false)}
          onSave={(toAdd, toRemove) => {
            setDestIDsToAdd(toAdd);
            setDestIDsToRemove(toRemove);

            if (selectedEventIDs.length >= 5) {
              setEditDestinationsModalOpen(false);
              setConfirmEditDestinationsModalOpen(true);
              return;
            }

            saveDestinations(toAdd, toRemove);
          }}
          selectedDestinations={selectedDestinations}
          selectedEventIDs={selectedEventIDs}
        />
      )}

      {confirmEditDestinationsModalOpen && (
        <BulkOperationConfirmationModal
          actionVerb="edit destinations"
          selectedEventIDs={selectedEventIDs}
          onClose={() => {
            setConfirmEditDestinationsModalOpen(false);
            setDestIDsToAdd(new Set());
            setDestIDsToRemove(new Set());
          }}
          onConfirm={() => {
            saveDestinations(destIDsToAdd, destIDsToRemove);
          }}
        />
      )}

      <MenuButton
        label="Edit Destinations"
        menuID="edit-destinations-menu"
        onClick={() => {
          setEditDestinationsModalOpen(true);
        }}
        showArrow={false}
      />
    </>
  );
}

export default BulkEditDestinationsMenu;
